import { trackEvent } from '@/utils/track/tools.js'

export default {
  /**
   * 广告创建页曝光
   * @param from_source 来源 1(管理端广告首页) 2(门店端广告首页)
   * @param terminal_type 3(pc) 2(pad) 4(exe)
   */
  showCreatePlan(from_source, terminal_type) {
    trackEvent({
      eventId: 'sailing_b_m_ads_createplan_sw',
      eventLabel: '管理端-广告-创建广告页面的曝光',
      attrs: {
        from_source,
        terminal_type,
      },
    })
  },
  adCreatePlanCK(attrs = {}) {
    trackEvent({
      eventId: 'sailing_b_m_ads_createplan_button_ck',
      eventLabel: '广告-创建广告计划页-点击',
      attrs,
    })
  },
}
